module.exports = __webpack_public_path__ + "img/profile.7bc72a22.png";